export const VALUE = 'value';
export const SELECTION = 'selection';
export const ACTIONS = 'actions';

export type ColumnTypeType = VALUE | SELECTION | ACTIONS;
